import { render } from "./MediaImageEditor.vue?vue&type=template&id=97162608"
import script from "./MediaImageEditor.vue?vue&type=script&lang=js"
export * from "./MediaImageEditor.vue?vue&type=script&lang=js"

import "./MediaImageEditor.vue?vue&type=style&index=0&id=97162608&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__